import { SERVER_IP } from 'assets/Config';
import { formQueryStringFromObject } from 'helpers';
import { store } from 'redux/store';

const DASHBOARD_BASE_URL = `${SERVER_IP}api/dashboard`;

const normalizeParams = (params = {}) => {
	const { branchId, isSuperAdmin = false, ...rest } = params;
	const validationError = !isSuperAdmin && !branchId ? 'branchId is required unless isSuperAdmin=true' : null;

	return {
		validationError,
		queryParams: {
			...rest,
			isSuperAdmin,
			branchId,
		},
	};
};

const readResponseBody = async (response) => {
	const rawText = await response.text();
	if (!rawText) return null;
	try {
		return JSON.parse(rawText);
	} catch (error) {
		return rawText;
	}
};

const buildErrorResult = (status, payload, fallbackMessage) => {
	const parsedMessage =
		(payload && typeof payload === 'object' && (payload.message || payload.error)) ||
		(typeof payload === 'string' ? payload : null) ||
		fallbackMessage;

	return {
		data: null,
		error: {
			status,
			message: parsedMessage,
			payload,
		},
		status,
	};
};

const dashboardFetch = async (path, params = {}, token) => {
	const { validationError, queryParams } = normalizeParams(params);

	if (validationError) {
		return buildErrorResult(400, null, validationError);
	}

	const queryString = formQueryStringFromObject(queryParams);
	const url = `${DASHBOARD_BASE_URL}${path}${queryString ? `?${queryString}` : ''}`;
	const authToken = token || store.getState()?.loginRedux?.token;

	try {
		const response = await fetch(url, {
			headers: {
				Authorization: `Bearer ${authToken}`,
				Accept: 'application/json',
			},
		});

		const payload = await readResponseBody(response);

		if (response.ok) {
			return { data: payload, error: null, status: response.status };
		}

		const fallback =
			response.status === 401
				? 'Unauthorized. Please login again.'
				: response.status >= 500
				? 'Server error while fetching dashboard customers.'
				: 'Unable to fetch dashboard customers.';

		return buildErrorResult(response.status, payload, fallback);
	} catch (error) {
		return buildErrorResult(500, error, 'Unable to reach dashboard services.');
	}
};

export const fetchDashboardCustomers = (params = {}, token) => dashboardFetch('/customers', params, token);

export const fetchDashboardCustomersSummary = (params = {}, token) =>
	dashboardFetch('/customers/summary', params, token);

export const fetchDashboardCustomerTrends = (params = {}, token) =>
	dashboardFetch('/customers/trends', params, token);

export const fetchDashboardCustomerBirthdays = (params = {}, token) =>
	dashboardFetch('/customers/birthdays', { daysAhead: 10, ...params }, token);

export const fetchDashboardCustomerReferrers = (params = {}, token) =>
	dashboardFetch('/customers/referrers', { limit: 5, ...params }, token);
